import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { NavigationInfo } from '@shared/generalInterfaces';
import { Observable } from 'rxjs';
import { NavigationState, NavigationStore } from './navigation-store';

@Injectable({ providedIn: 'root' })
export class NavigationQuery extends Query<NavigationState> {
	//transitionsStack$: Observable<NavigationInfo[]> = this.select((state) => state.transitionsStack);

	constructor(protected store: NavigationStore) {
		super(store);
	}
    
    get transitionsStack(): NavigationInfo[] {
		return this.getValue().transitionsStack;
	}
	
	peekTransition(): NavigationInfo {
		const { transitionsStack } = this;
		if(transitionsStack.length < 1) return null;
		return transitionsStack[transitionsStack.length - 1];
	}
}